import React from 'react';
import styles from '../../../styles/TaskDetails.module.css';

interface CountdownTimerProps {
  timeRemaining: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    total: number;
  };
  taskStatus?: string;
}

const CountdownTimer: React.FC<CountdownTimerProps> = ({ timeRemaining, taskStatus }) => {
  const isOverdue = timeRemaining.total <= 0;
  const isUrgent = timeRemaining.days === 0 && timeRemaining.hours < 24;
  
  // Don't show countdown if task is completed
  if (taskStatus === 'completed') {
    return (
      <div style={{display:'flex',justifyContent:'end'}}>
        <div className={styles.countdownTimer}>
        </div>
      </div>
    );
  }
  
  return (
    <div style={{display:'flex',justifyContent:'end'}}>
      <div className={styles.countdownTimer}>
        <div className={`${styles.countdownDisplay} ${isOverdue ? styles.overdue : ''} ${isUrgent ? styles.urgent : ''}`}>
          <div className={styles.timeUnit}>
            <div className={styles.timeValue}>{Math.abs(timeRemaining.days)}</div>
            <div className={styles.timeLabel}>Days</div>
          </div>
          <div className={styles.timeSeparator}>:</div>
          <div className={styles.timeUnit}>
            <div className={styles.timeValue}>{Math.abs(timeRemaining.hours).toString().padStart(2, '0')}</div>
            <div className={styles.timeLabel}>Hours</div>
          </div>
          <div className={styles.timeSeparator}>:</div>
          <div className={styles.timeUnit}>
            <div className={styles.timeValue}>{Math.abs(timeRemaining.minutes).toString().padStart(2, '0')}</div>
            <div className={styles.timeLabel}>Minutes</div>
          </div>
          <div className={styles.timeSeparator}>:</div>
          <div className={styles.timeUnit}>
            <div className={styles.timeValue}>{Math.abs(timeRemaining.seconds).toString().padStart(2, '0')}</div>
            <div className={styles.timeLabel}>Seconds</div>
          </div>
        </div>
        
        {isOverdue && (
          <div className={styles.overdueWarning}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
              <line x1="12" y1="9" x2="12" y2="13"></line>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
            Task is overdue!
          </div>
        )}
        
        {isUrgent && !isOverdue && (
          <div className={styles.urgentWarning}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
              <line x1="12" y1="9" x2="12" y2="13"></line>
              <line x1="12" y1="17" x2="12.01" y2="17"></line>
            </svg>
            Less than 24 hours remaining!
          </div>
        )}
      </div>
    </div>
  );
};

export default CountdownTimer;

